import { ArrowRight } from '@phosphor-icons/react';
import { Badge } from '@/components/ui';

interface TemplateCard {
  name: string;
  subtitle: string;
  audience: string;
  image: string;
}

const TEMPLATES: ReadonlyArray<TemplateCard> = [
  {
    name: 'The Brutalist',
    subtitle: 'Typography-led. High contrast.',
    audience: 'Designers',
    image: 'https://images.unsplash.com/photo-1620336655174-32f22a5712f2?w=1200&q=80',
  },
  {
    name: 'The Dev Log',
    subtitle: 'Syntax highlighting. Timeline focus.',
    audience: 'Engineers',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80',
  },
  {
    name: 'The Narrator',
    subtitle: 'Deep reading layout. Editorials.',
    audience: 'Writers',
    image: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=1200&q=80',
  },
  {
    name: 'The Lens',
    subtitle: 'Masonry grids. Native lazy loading.',
    audience: 'Visual Artists',
    image: 'https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=1200&q=80',
  },
];

export function TemplateGallery() {
  return (
    <section id="templates" className="bg-canvas py-32">
      <div className="mx-auto max-w-container px-6">
        <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <h2 className="mb-4 font-display text-3xl font-semibold tracking-tight md:text-4xl">
              Starting Points
            </h2>
            <p className="max-w-xl text-lg text-ink-muted">
              Four templates right now. More coming. Pick one and stop overthinking it.
            </p>
          </div>
          <button
            type="button"
            className="flex items-center gap-2 border-b border-ink pb-1 text-sm font-medium transition-colors hover:text-ink-muted hover:border-ink-muted"
          >
            view all templates (there are 4) <ArrowRight size={14} />
          </button>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
          {TEMPLATES.map((t) => (
            <a key={t.name} href="#" className="group block">
              <div className="relative mb-4 aspect-[4/3] overflow-hidden rounded-xl border border-line bg-board shadow-card">
                <img
                  src={t.image}
                  alt={`${t.name} template preview`}
                  className="h-full w-full object-cover opacity-90 grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
                  loading="lazy"
                />
                <span className="absolute inset-0 bg-ink/0 transition-colors duration-300 group-hover:bg-ink/5" />
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="text-lg font-semibold text-ink">{t.name}</h4>
                  <p className="text-sm text-ink-muted">{t.subtitle}</p>
                </div>
                <Badge tone="neutral" className="normal-case tracking-normal">
                  {t.audience}
                </Badge>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
